/**
 * <zh/> 布局的基类
 *
 * <en/> Base class for layout
 */
export class BaseLayout {
    constructor(context, options) {
        this.context = context;
        this.options = options || {};
    }
}
//# sourceMappingURL=base-layout.js.map